// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__33-_h","sendOtp":"AuthorizeToLogin_sendOtp__1l98U"};